<template>
  <v-app id="inspire">
    <v-app-bar
      fixed
      color="primary"
      dark
    >
      <v-spacer></v-spacer>
      <v-toolbar-title>{{ $clienteNomeFantasia }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-select
        :items="locales"
        item-text="name"
        item-value="key"
        v-model="localeSelected"
        hide-details
        single-line
        style="max-width: 250px"
        @change="changeLocale"
        return-object
        no-data
      >
        <template v-slot:item="{ item }">
          <country-flag :country='item.flag' size='normal'/>
          <span>{{ item.name}}</span>
        </template>

        <template v-slot:prepend-inner>
          <country-flag :country='localeSelected.flag' size='normal'/>
        </template>
      </v-select>
    </v-app-bar>
    <v-content>
      <v-container
        fluid
        fill-height
        grid-list-xl
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex>
            <v-layout
              row
              wrap
              align-content-start
              justify-center
              fill-height
            >
              <v-flex
                xs12
                sm8
                md4
                lg4
                xl4
                class="pa-3"
              >
                <template>
                  <v-card class=" d-flex justify-center align-center flex-column mx-auto elevation-2">
                    <v-img
                      height="200px"
                      width="50%"
                      :src="`logo-grande.png`"
                      contain
                    >
                      <template v-slot:placeholder>
                        <v-layout
                          fill-height
                          align-center
                          justify-center
                          ma-0
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-layout>
                      </template>
                    </v-img>

                    <!-- <v-card-title style="font-size: 24px ">{{
                      $clienteNomeFantasia
                    }}</v-card-title> -->

                    <v-card-text
                      class="text-justify"
                      style="font-size: 18px"
                    >
                      {{ locale[local].screen.login.messageCardLeft }}
                    </v-card-text>
                  </v-card>
                </template>
              </v-flex>
              <v-flex
                xs12
                sm8
                md4
                lg4
                xl4
                class="align-self-center"
              >
                <cgi-login @home="setComponent"></cgi-login>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <cgi-footer />
  </v-app>
</template>

<script>
import CardLoginVue from "../components/CardLogin";
import Footer from "../components/core/Footer.vue";
import HomeVue from "./Home";
export default {
  components: {
    "cgi-login": CardLoginVue,
    "cgi-footer": Footer,
  },
  data: () => ({
    localeSelected: {
      flag: 'br'
    },
    locales: [
      {
        name: 'Português - Brasil',
        key: 'pt-BR',
        flag: 'br'
      },
      {
        name: 'Inglês',
        key: 'en-US',
        flag: 'us'
      },
       {
        name: 'Espanhol',
        key: 'es',
        flag: 'es'
      }
    ]
  }),
  mounted() {
    this.localeSelected = this.locales.filter((locale) => locale.key == window.local)[0]

    if (sessionStorage.getItem("logado") === "true") {
      this.$emit("home", HomeVue);
    }
  },
  methods: {
    setComponent(val) {
      this.$emit("home", val);
    },
    changeLocale(local) {
      localStorage.setItem('local', local.key)
      window.location.reload()
    }
  },
  props: {
    source: String,
  },
};
</script>
